/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestPaymentDto } from '../../models/contents-request-payment-dto';
import { CreateContentsRequestPaymentDto } from '../../models/create-contents-request-payment-dto';

export interface ContentsRequestPaymentControllerCreate$Params {
      body: CreateContentsRequestPaymentDto
}

export function contentsRequestPaymentControllerCreate(http: HttpClient, rootUrl: string, params: ContentsRequestPaymentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestPaymentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestPaymentDto>;
    })
  );
}

contentsRequestPaymentControllerCreate.PATH = '/api/contents-request-payment';
